import { signOut, useFirebaseAuth } from '@/utils/firebase';
import { Box, Stack } from '@mui/material';
import { SignOutIcon } from '@phosphor-icons/react';
import { IconButton, PRIMARY_COLOR } from '@repo/ui';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Logo from '../components/Logo.js';
import { SnackbarProvider } from '../context/SnackbarContext.js';

const MOBILE_HEADER_HEIGHT = 56;

export default function AgentMobileLayout() {
  const navigate = useNavigate();
  const { user: firebaseUser } = useFirebaseAuth();
  const queryClient = useQueryClient();

  const handleLogout = useCallback(async () => {
    try {
      await signOut();
    } finally {
      queryClient.clear();
      navigate('/agent/auth/login');
    }
  }, [navigate, queryClient]);

  return (
    <SnackbarProvider>
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Mobile Header */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            height: MOBILE_HEADER_HEIGHT,
            px: 2,
            backgroundColor: PRIMARY_COLOR.hex,
            flexShrink: 0,
          }}
        >
          <Logo useWhiteLogo height={28} />
          {firebaseUser && (
            <IconButton
              tooltip="Log out"
              onClick={handleLogout}
              sx={{
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.16)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.24)',
                },
              }}
            >
              <SignOutIcon size={20} />
            </IconButton>
          )}
        </Stack>

        {/* Scrollable Content */}
        <Box sx={{ flex: 1, overflow: 'auto', backgroundColor: '#FAFAFA' }}>
          <Outlet />
        </Box>
      </Box>
    </SnackbarProvider>
  );
}
